import {createSelector, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {BookingInfo, BookingStatus, BookingStatusValues} from '../../schema'

const initialState: BookingInfo = {
  bookingId: null,
  status: BookingStatusValues.Inactive
}

export const bookingSlice = createSlice({
  name: 'booking',
  initialState,
  reducers: {
    setBookingId: (state, action: PayloadAction<string>) => {
      state.bookingId = action.payload
    },
    setBookingStatus: (state, action: PayloadAction<BookingStatus>) => {
      state.status = action.payload
    },
    clearBooking: () => {
      return {...initialState}
    }
  }
})

// selectors
export const selectBooking = (state: any): BookingInfo => {
  return state.booking
}

export const selectBookingId = createSelector(
  selectBooking,
  (booking: BookingInfo): string | null | undefined => {
    return booking.bookingId
  }
)

export const selectBookingStatus = createSelector(
  selectBooking,
  (booking: BookingInfo): BookingStatus => {
    return booking.status
  }
)

// actions
export const {
  setBookingId,
  setBookingStatus,
  clearBooking
} = bookingSlice.actions

// reducer
export default bookingSlice.reducer
